import { MdSearch } from 'react-icons/md';
import Input from 'components/Input/Input';

type EntityFilterInputProps = {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
};

export const EntityFilterInput = ({
  value,
  onChange,
  label = 'Search entities',
  disabled = false,
}: EntityFilterInputProps) => (
  <Input
    label={label}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    invalid={false}
    required={false}
    disabled={disabled}
    type="text"
    id="entity-filter"
    wrapperPaddingBottom="12px"
    startAdornment={
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingLeft: '14px',
          paddingRight: '8px',
          color: '#6c757d',
        }}
      >
        <MdSearch size={18} />
      </span>
    }
  />
);

export default EntityFilterInput;
